export default __webpack_public_path__ + "static/hacktoberfest-contributor-0c87d6b9edd34f4c7ac267254ac44dc4.png";